import RBush from 'rbush';

import { Cluster, RBushItem } from 'shared/types/Map';
import { getExtendedTileBBox } from 'shared/utils/map/tiles';

import { createTileConstructor } from './internal/utils/createTileConstructor';

export type PinsLayerOptions = {
  map: YMaps.Map;
  rbush: RBush<RBushItem>;
};

export function definePinsLayer(ymaps: YMaps.IYMaps): void {
  if (ymaps.modules.isDefined('PinsLayer')) {
    return;
  }

  ymaps.modules.define<[YMaps.util.IHd, typeof YMaps.Layer]>(
    'PinsLayer',
    // Два модуля зависимостей в конце - обязательные, хоть и не используются в классе, не удалять
    ['util.hd', 'Layer', 'util.pixelBounds', 'layer.tileContainer.DomContainer'],
    (provide, utilHd, Layer) => {
      class PinsLayer {
        public readonly layer: YMaps.Layer;

        private map: YMaps.Map;
        private mapProjection: YMaps.projection.wgs84Mercator;
        private rbush: RBush<RBushItem>;

        public constructor(options: PinsLayerOptions) {
          this.map = options.map;
          this.mapProjection = this.map.options.get('projection');
          this.rbush = options.rbush;

          this.layer = new Layer(() => null, {
            tileClass: createTileConstructor({
              dpr: utilHd.getPixelRatio(),
              getClustersForTile: this.getClustersForTile,
              mapProjection: this.mapProjection,
            }),
            tileContainerClass: 'default#dom',
            tileTransparent: true,
          });
        }

        private getClustersForTile = (tileNumber: YMaps.TTileNumber, zoom: number): Cluster[] => {
          const extendedTileBox = getExtendedTileBBox({
            includeShadow: true,
            tileNumber,
            zoom,
          });
          const rBushItems = this.rbush.search(extendedTileBox);

          return rBushItems.map(({ cluster }) => cluster);
        };
      }

      provide(PinsLayer);
    },
  );
}
